import Cookies from 'js-cookie';
import { $, delegate, $$, addEventListenerAll } from '../helper/utils';

const addToCartBtn = $('.add-to-cart');
const openCartBtn = $$('.open-productcart');
// const mobileCartBtn = $('.open-productcart.mobile');
const cartWrapper = $('.productcart-wrapper');
const productcart = $('.productcart');
const cartItemList = $('.productcart-item-list');
const cartItemCount = $$('.productcart-item-count');
const orderList = $('.order-list');
const cartSubmitBtns = $$('.order-btn');
const headerCartSubmitBtn = cartWrapper.querySelector('.order-btn');
const isIE = (
  document.documentElement.classList.contains('ie')
  || document.documentElement.classList.contains('edge')
);
// const cartAddElement = document.createElement('div');

const observerOptions = {
  characterDataOldValue: !isIE,
  attributes: isIE,
  childList: true,
};

// // add cart placeholder to dom
// cartAddElement.className = 'cart-add-placeholder line-image';
// cartAddElement.innerHTML = '<img alt="">';
// document.body.appendChild(cartAddElement);


// toggle button focus ability
function toggleCartButtonTabindex(enable) {
  const btns = productcart.querySelectorAll('button, a');

  for (let i = 0; i < btns.length; i++) {
    const el = btns[i];

    if (enable) {
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('tabindex', -1);
    }
  }
}

function hideCart(e) {
  if (
    e && e.type === 'focusout'
    && e.relatedTarget && e.relatedTarget.classList.contains('productcart-item-remove')
  ) {
    return;
  }

  toggleCartButtonTabindex(false);
  productcart.setAttribute('aria-hidden', true);

  requestAnimationFrame(() => {
    cartWrapper.classList.remove('open');
  });
}

function toggleCartVisibility() {
  if (cartWrapper.classList.contains('open')) {
    toggleCartButtonTabindex(false);
    productcart.setAttribute('aria-hidden', true);
  } else {
    toggleCartButtonTabindex(true);
    productcart.setAttribute('aria-hidden', false);
  }


  requestAnimationFrame(() => {
    cartWrapper.classList.toggle('open');
  });
}

let cartStateDelay;
function addToCart() {
  const { id,text } = this.dataset;

  if (id === '') {
    console.warn('No ID set', this);
    return;
  }

  clearTimeout(cartStateDelay);

  try {
    const cartCookie = Cookies.get('cartItems');
    const cartItems = cartCookie ? cartCookie.split(',') : [];
    const gridItem = this.closest('.grid-item');
    const img = gridItem.querySelector('img');
    const title = gridItem.querySelector('h4').innerHTML;

    // create new cart item
    const cartItem = document.createElement('li');
    cartItem.classList.add('productcart-item');
    cartItem.innerHTML = `
      <div class="productcart-item-image line-image" data-id="${id}">
        <img src="${img.src}" alt="">
      </div>
      <div class="productcart-item-text">
        <strong>${title}</strong>
        <br>${text}
      </div>
      <button class="productcart-item-remove" type="button" data-id="${id}">
        <i class="icon-trash"></i>
      </button>
      <input type="hidden" name="products[]" value="${id}">
    `;

    if (cartItemList.querySelector('.productcart-item') === null) {
      cartItemList.innerHTML = '';
    }
    
    // add new item to cart list and scroll to bottom of list
    cartItemList.appendChild(cartItem);
    cartItemList.scrollTop = cartItemList.offsetHeight;

    // update cookie
    cartItems.push(id);
    cartItems.join(',');
    // Cookies.set('cartItems', cartItems.join(','),
    //   { expires: 30, secure: false, sameSite: 'strict' });
    // create ajax request
    const url = '/veo/ajaxRequest.php';
    const lang = document.querySelector('body').getAttribute('data-langid');
    const bodyData = new FormData();
    bodyData.append('lang', lang);
    bodyData.append('c', 'enY0bnpRejZnM00yR3dubkJPcUNZLytyRTRjbFNlM01QakY0K0hnRzRyeEUvcWV6WXMwbm5SNmZaMVVWYnF1TA==');
    bodyData.append('m', 'b2lWZVZsMjZPZHpZNzRabnFNcFhkdz09');
    bodyData.append('items', JSON.stringify(cartItems));

    fetch(url, {
      method: 'POST',
      mode: 'same-origin',
      cache: 'no-cache',
      body: bodyData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        $('.productcart-item-list').setAttribute('data-items', data);
      })
      .catch((error) => {
        console.error(error);
      });

    this.classList.add('success');
  } catch (error) {
    this.classList.add('error');
    console.error(error);
  }

  cartStateDelay = setTimeout(() => {
    this.classList.remove('success');
    this.classList.remove('error');
  }, 1250);
}

function removeFromCart(orderItem = false) {
  const { id } = this.dataset;
  const cartItems = document.querySelectorAll('.productcart-item');
  
  const url = '/veo/ajaxRequest.php';
  const lang = document.querySelector('body').getAttribute('data-langid');
  const bodyData = new FormData();
  bodyData.append('lang', lang);
  bodyData.append('c', 'enY0bnpRejZnM00yR3dubkJPcUNZLytyRTRjbFNlM01QakY0K0hnRzRyeEUvcWV6WXMwbm5SNmZaMVVWYnF1TA==');
  bodyData.append('m', 'VDZsaHlvRlVBenA5SlRMYmt5NDFBSEk0REdDL09WelRLY2IzNHhLNWFuOD0=');
  bodyData.append('item', JSON.stringify(id));

  fetch(url, {
    method: 'POST',
    mode: 'same-origin',
    cache: 'no-cache',
    body: bodyData,
  })
    .then((response) => {
      console.log(response.text());
    })
    .catch((error) => {
      console.warn(error);
    });

  // remove element from dom
  if (orderItem === true) {
    orderList.removeChild(this.closest('.order-item'));

    // also remove item from cart list
    const el = cartItemList.querySelector(`.productcart-item-remove[data-id="${id}"]`);
    cartItemList.removeChild(el.parentElement);
  } else {
    cartItemList.removeChild(this.parentElement);

    // also remove item from order list
    if (orderList !== null) {
      const el = orderList.querySelector(`.productcart-item-remove[data-id="${id}"]`);
      orderList.removeChild(el.closest('.order-item'));
    }
  }
}

export default function cart() {
  // enable cart submit buttons if cart has elements
  if (cartItemList.firstElementChild && cartItemList.firstElementChild.className !== '') {
    for (let i = 0; i < cartSubmitBtns.length; i++) {
      const el = cartSubmitBtns[i];
      el.disabled = false;
      el.classList.remove('disabled');
    }
  }

  // add remove buttons click handler
  delegate(document.body, 'click', '.productcart-item-list .productcart-item-remove', function () {
    removeFromCart.call(this);
  }, { passive: true });

  // order page order item remove handler
  if (orderList !== null) {
    delegate(orderList, 'click', '.productcart-item-remove', function () {
      removeFromCart.call(this, true);
    }, { passive: true });
  }

  if (addToCartBtn !== null) {
    delegate(document.body, 'click', '.add-to-cart', addToCart, { passive: true });
  }

  // hide cart on outside click
  window.addEventListener('click', (e) => {
    if (
      e.target !== cartWrapper
      && cartWrapper.contains(e.target) === false
      && e.target.classList.contains('productcart-item-remove') === false
      && e.target.classList.contains('add-to-cart') === false
      && e.target.classList.contains('open-productcart') === false
    ) {
      hideCart.call(cartWrapper);
    }
  });

  // when tabing trough cart, close it on outside tab
  headerCartSubmitBtn.removeEventListener('focusout', hideCart);
  headerCartSubmitBtn.addEventListener('focusout', hideCart);
  // setup click handler for cart toggle buttons
  addEventListenerAll(openCartBtn, 'click', toggleCartVisibility, { passive: true });
  // openCartBtn.removeEventListener('focus', showCart);
  // openCartBtn.addEventListener('focus', showCart);

  // observer cart item list for changes
  const observer = new MutationObserver(() => {
    // ignore empty cart placeholder
    if (cartItemList.firstElementChild && cartItemList.firstElementChild.className === '') {
      return;
    }

    const count = Math.max(cartItemList.childElementCount, 0);
  
    console.log(count);
  
    // add empty text if no items in cart
    if (count === 0) {
      cartItemList.innerHTML = `<li>${cartItemList.dataset.empty}<li>`;
    }

    // update cart button disabled state
    for (let i = 0; i < cartSubmitBtns.length; i++) {
      const el = cartSubmitBtns[i];
      el.disabled = count === 0;

      if (count === 0) el.classList.add('disabled');
      else el.classList.remove('disabled');
    }

    // update cart item counters
    for (let j = 0; j < cartItemCount.length; j++) {
      const el = cartItemCount[j];
      el.textContent = count;
      el.style.opacity = Math.sign(count);
    }
  });

  // init observer
  observer.observe(cartItemList, observerOptions);
}

// polyfill closest function
if (!Element.prototype.matches) {
  Element.prototype.matches = (
    Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
  );
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    let el = this;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}


// // animate cart item to cart
// if (cartAddElement) {
//   // add image
//   cartAddElement.firstElementChild.src = img.src;

//   // set initial size and position
//   const imageOffset = offset(img);
//   gsap.set(cartAddElement, {
//     width: imageOffset.width,
//     height: imageOffset.height,
//     left: imageOffset.left,
//     top: imageOffset.top,
//   });

//   // get first state
//   const first = offset(img);

//   const last = offset(cartWrapper);
//   gsap.set(cartAddElement, {
//     width: 40,
//     height: 40,
//     left: last.left,
//     top: last.top,
//   });

//   // // calculate differences between first and last state
//   const invertx = first.left - last.left;
//   const inverty = first.top - last.top;
//   const invertsx = first.width / last.width;
//   const invertsy = first.height / last.height;

//   gsap.fromTo(cartAddElement, {
//     x: invertx,
//     y: inverty,
//     scaleX: invertsx,
//     scaleY: invertsy,
//     opacity: 1,
//     visibility: 'hidden',
//   }, {
//     duration: 0.775,
//     x: 0,
//     y: 0,
//     scaleX: 1,
//     scaleY: 1,
//     visibility: 'inherit',
//     ease: 'sine.out',
//   }).then(() => {
//     gsap.to(cartAddElement, {
//       duration: 0.175,
//       opacity: 0,
//       ease: 'sine.out',
//     });
//   });
// }
